import styled from 'styled-components';
import { ink, space, typeScale } from '@repo/design-tokens';

/**
 * The body of the Equipment step's destructive confirmations — *Remove From Register* on the asset
 * card (`equipment-page-asset-card`) and *Undo this import?* (`equipment-page-undo-import`). One
 * block, so the two read alike.
 */
export const EquipmentModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  color: ${ink[1]};
  font-size: ${typeScale.body1.fontSize};
  line-height: ${typeScale.body1.lineHeight};

  p {
    margin: 0;
  }
  ul {
    margin: 0;
    padding-left: ${space[4]};
  }
`;
